// ============================================================
// Condivisione nativa (Web Share API) con fallback "copia link"
// ============================================================
// Markup in snippets/social-share.liquid: `button.mm-share` con
// data-share-title, data-share-url e data-copied-text.
// Su dispositivi con navigator.share si apre il foglio di condivisione
// del sistema (messaggi, WhatsApp, Instagram, copia, ...). Altrove il
// link viene copiato negli appunti e il bottone mostra un feedback.
// Delegazione sul document: funziona anche per i bottoni inseriti dopo
// il load (quick buy, sezioni ricaricate nell'editor).

const FEEDBACK_MS = 2000;

async function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  ta.remove();
}

function showCopied(btn) {
  btn.classList.add('is-copied');
  clearTimeout(btn._mmShareTimer);
  btn._mmShareTimer = setTimeout(() => btn.classList.remove('is-copied'), FEEDBACK_MS);
}

async function share(btn) {
  const url = btn.dataset.shareUrl || window.location.href;
  const title = btn.dataset.shareTitle || document.title;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (err) {
      // Utente ha chiuso il foglio: nessun fallback.
      if (err && err.name === 'AbortError') return;
      // Altri errori (es. share non permesso nel contesto): copia link.
    }
  }

  try {
    await copyToClipboard(url);
    showCopied(btn);
  } catch {
    window.prompt(title, url);
  }
}

document.addEventListener('click', (evt) => {
  const btn = evt.target.closest('.mm-share');
  if (!btn) return;
  evt.preventDefault();
  share(btn);
});
